import { render } from "./PortfolioViewMobile.vue?vue&type=template&id=28ca50ac"
import script from "./PortfolioViewMobile.vue?vue&type=script&lang=js"
export * from "./PortfolioViewMobile.vue?vue&type=script&lang=js"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__